import type { FaireProductEntity } from "../../entity_types/product";

export const p_nmvgqas665: FaireProductEntity = {
  token: "p_nmvgqas665",
  type: "product",
  name: "Cozy Open-Front Knit Cardigan",
  brandToken: "b_dilw26syov",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0580e0ca5cc458f777208ac9de0c43243600ccc06eb6e3995719c8fd880e86e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bd24995bda33e620501909f357908d492f70dd045d0e87fa3773ec79afe1abc.jpeg",
    "https://cdn.faire.com/fastly/84a7901301b3a418f8143fc06b205ca21da3af291fd79f0f3461e7183b8c52e2.jpeg",
    "https://cdn.faire.com/fastly/8a2758b0733317b63fe595bbcd4412081a6ec977df433f9fe9f81ba75409e050.jpeg",
    "https://cdn.faire.com/fastly/d25cbcc7bc8bc9eb267275250a5e308c1dcfce0dcab4c95dc667adc574470b2b.jpeg",
    "https://cdn.faire.com/fastly/d5028b23f45929796a545d06e23802195e543fe88d52ba45958492cef077dd24.jpeg",
    "https://cdn.faire.com/fastly/6405957149bc04c3e7d04b9c22fb9c12818c14de9c0145aab124571b276f7d3e.jpeg",
    "https://cdn.faire.com/fastly/13cc14fa6638e47c72b65074e77dbe1449597fc336d22886a62937b31b122ca1.jpeg",
    "https://cdn.faire.com/fastly/fad46b0cb6e7acee91abf24a460c5ebfd7905155acf2c24f29212a140a39034e.jpeg",
    "https://cdn.faire.com/fastly/397583f56737ddab7039242bc692dbc0ae794faf53524c5a1b9e92145b51f492.jpeg",
    "https://cdn.faire.com/fastly/4338aa45c66381f46d8d85fb50fd0e9521a3f2e6d1ae25ae7242cbee1074dce0.jpeg",
    "https://cdn.faire.com/fastly/fb673071781c7d65e23d9f84e72354d050c049859101cc28c32f240cd81e0e9f.jpeg",
    "https://cdn.faire.com/fastly/001934cf513e596dd6aeecbef12319d36fccb10cc3cd0c57f2acff6b27ccf1fb.jpeg",
    "https://cdn.faire.com/fastly/4516e32b07c27dc60f88d741d8066fb62d4267badefbc3fbfb5fd10b4be5f68e.jpeg",
    "https://cdn.faire.com/fastly/d8db9454ebdb8c22b67372b016b8231f0dcd2bedb6774abdf47ffc0751a40a79.jpeg",
    "https://cdn.faire.com/fastly/0ed9d0bf9826084894447670b7148c97c852fb6388a5d6a3a475fea532e906f8.jpeg",
    "https://cdn.faire.com/fastly/61c4b2587784266569c03641e466e4314a345a353990193f0252b8adce14d711.jpeg",
    "https://cdn.faire.com/fastly/414765b3330a8f9eb9ef70c8f1a75173be3824ea4296a433fd4933011804735a.jpeg",
    "https://cdn.faire.com/fastly/8445ea6794543ea7ea8039d1d183e3f2365c4372ceb42704fc67ab7c5bfa3c85.jpeg",
    "https://cdn.faire.com/fastly/47affa2262aa72630ca5b3016d4de2ac5f9852347cc432d00743d9cfd2f65cae.jpeg",
  ],
  priceDollars: 122.14,
  description:
    "Wrap yourself in effortless comfort with this timeless open-front cardigan. Crafted from a soft, lightweight knit, it drapes beautifully and adds the perfect layer of warmth without bulk. The relaxed silhouette and longline cut make it ideal for casual days or cozy evenings in. Whether paired with jeans, leggings, or a slip dress, this cardigan instantly elevates any outfit.",
  tags: [],
  msrpDollars: 244.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:09.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
